'use client';

import { useEffect } from 'react';
import { track } from '@vercel/analytics';

import { parseBookingBooked } from './bookingMessage';
import { captureVisitAttribution, getVisitAttribution } from './visitAttribution';

// Consent-free booking counter. Listens for the ServiceTitan scheduler's
// `BookingBooked` postMessage and fires a Vercel event with non-PII attribution
// context. Vercel track() ONLY — never dataLayer — so GA4 (which already gets
// bookings via a separate consent-gated relay) is not double-counted.
const BOOKING_EVENT = 'booking_confirmed';

export default function BookingConfirmedTracker() {
  useEffect(() => {
    captureVisitAttribution();

    const seenIds = new Set<string>();

    const onMessage = (event: MessageEvent) => {
      const booking = parseBookingBooked(event.origin, event.data);
      if (!booking) return;

      // Dedup by appointment id (unique per booking; the parser guarantees a
      // non-empty id). A repeated message for the same booking fires once.
      if (seenIds.has(booking.st_booking_id)) return;
      seenIds.add(booking.st_booking_id);

      const payload: Record<string, string> = {
        ...getVisitAttribution(),
        opened_from: window.location.pathname,
        st_booking_id: booking.st_booking_id,
      };
      if (booking.scheduler) payload.scheduler = booking.scheduler;

      track(BOOKING_EVENT, payload);
    };

    window.addEventListener('message', onMessage, true);
    return () => window.removeEventListener('message', onMessage, true);
  }, []);

  return null;
}
